import { createRouter, createWebHistory } from 'vue-router'
import { ref } from 'vue'

const routes = [
  {
    path: '/',
    name: 'Recent',
    component: () => import('../views/Recent.vue')
  },
  {
    path: '/wiki/:pathMatch(.*)*',
    name: 'WikiPage',
    component: () => import('../views/Page.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('../views/Register.vue')
  },
  {
    path: '/search',
    name: 'Search',
    component: () => import('../views/Search.vue')
  },
  {
    path: '/workbench',
    name: 'Workbench',
    component: () => import('../views/Workbench.vue')
  },
  {
    path: '/history/:pathMatch(.*)*',
    name: 'History',
    component: () => import('../views/History.vue')
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import('../views/Profile.vue')
  },
  {
    path: '/settings',
    name: 'Settings',
    component: () => import('../views/Settings.vue')
  },
  {
    path: '/admin',
    name: 'Admin',
    component: () => import('../views/Admin.vue')
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

import { useAuthStore } from '../stores/auth'

// Global navigation guard
router.beforeEach((to, from, next) => {
  const authStore = useAuthStore()

  // Public routes
  const publicRoutes = ['/login', '/register']

  // Redirect to login if not authenticated and trying to access protected route
  if (!publicRoutes.includes(to.path) && !authStore.isAuthenticated) {
    next('/login')
  }
  // Redirect to home if authenticated and trying to access login/register
  else if ((to.path === '/login' || to.path === '/register') && authStore.isAuthenticated) {
    next('/')
  }
  // Admin route guard
  else if (to.path === '/admin' && !authStore.isAdmin) {
    next('/')
  }
  // Proceed normally
  else {
    next()
  }
})

export default router
